// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1TLeI","col":"styles_col__M5c_b","fulfillmentStatus":"styles_fulfillmentStatus__2Kjej","emailCol":"styles_emailCol__3QBu7"};